// When a student's time runs out, the backend auto-submits the session but doesn't record
// end_time (only a manual submit does). Fall back to when the session actually stopped: the
// due time, or the last activity if the student stopped before that.
export const getSessionEndTime = (session) => {
  if (!session) return null;
  if (session.end_time) return session.end_time;
  if (session.status !== "auto_submitted" && session.status !== "completed") return null;

  const lastSeen = session.last_activity || session.updatedAt;
  if (session.due_time && lastSeen) {
    return new Date(lastSeen) < new Date(session.due_time) ? lastSeen : session.due_time;
  }
  return session.due_time || lastSeen || null;
};
